import { Controller } from "@hotwired/stimulus"

export default class IndeterminateController extends Controller {
  connect() {
    this.element.indeterminate = true
  }
}
